import { useSearchParams } from 'react-router-dom';
import { UserManagement } from './UserManagement';
import { RolesPermissions } from '../roles/RolesPermissions';
import { PlatformAccessTab } from './PlatformAccessTab';
import { SecurityKernel } from '../security/SecurityKernel';

export type AdminHubTab = 'users' | 'roles' | 'permissions' | 'matrix' | 'access' | 'audit' | 'security';

interface UserManagementHubProps {
  initialTab?: AdminHubTab;
}

const adminTabs: readonly string[] = ['users', 'roles', 'permissions', 'matrix', 'access', 'audit', 'security'];

export function UserManagementHub({ initialTab = 'users' }: UserManagementHubProps) {
  const [searchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const activeTab = tabParam && adminTabs.includes(tabParam) ? tabParam as AdminHubTab : initialTab;
  const subParam = searchParams.get('sub');
  const securityTab = subParam === 'abac' || subParam === 'data-protection' || subParam === 'threat' ? subParam : 'auth';

  return (
    <div className="min-h-full bg-background text-foreground">
      <div className="w-full">
        {activeTab === 'users' && <UserManagement />}
        {(activeTab === 'roles' || activeTab === 'permissions' || activeTab === 'matrix') && <RolesPermissions />}
        {activeTab === 'access' && <PlatformAccessTab initialSubTab="access" />}
        {activeTab === 'audit' && <PlatformAccessTab initialSubTab="audit" />}
        {activeTab === 'security' && <SecurityKernel initialSubTab={securityTab} />}
      </div>
    </div>
  );
}
